<template>
  <button :class="className" :disabled="isLoading" :title="in18['page_compare_product']" class="btn" type="button" @click="toggleCompare">
    <img :alt="in18['page_compare_product']" class="img m-auto" src="/shop/images/scales-icon.svg">
  </button>
</template>

<script>
export default {
  props: {
    title:     String,
    productId: Number,
    className: {
      type:    String,
      default: '',
    },
    in18:      {
      type: Object,
    }
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    comparedProducts: {
      get() {
        return this.$store.getters.comparedProducts
      },
      set(value) {
        this.$store.dispatch('SET_COMPARED_PRODUCTS', value)
      },
    }
  },
  methods:  {
    toggleCompare() {

      if (this.isLoading) {
        return;
      }
      this.isLoading = true;

      this.comparedProducts = this.productId

      this.isLoading = false;
    },
  },
};
</script>
